import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Auth from '../Auth';
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

export default function Login() {
    const [password, setpassword] = useState('');

    const navigate = useNavigate();

    function handleSubmit(event) {
        event.preventDefault();
        Auth.Login(password)
            .then(result => {
                if (!result) {
                    toast.error("Invalid Login")
                    console.error("result " + result)
                } else {
                    //Hacky way to move navigation
                    window.location.reload(false);
                }
            })
    }

    return (
        <div className="row justify-content-center">
            <div className='col-lg-5'>
                <div className='card m-5'>
                    <div className='card-header'>
                        <span className="lead">Cannon Control Login</span>
                    </div>
                    <div className='card-body'>
                        <form onSubmit={handleSubmit}>
                            <div className='form-group mb-3'>
                                <p>Password</p>
                                <input name="password" type="password" className='form-control' value={password} onChange={e => setpassword(e.target.value)} required/>
                            </div>
                            <div>
                                <button className='btn btn-success d-inline-block' type="submit">Submit</button>
                            </div>
                            <div>
                                <a href = "mailto:info@margosupplies.com?subject=Cannon Control Demo">Looking for a Demo?</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}